import { createAction } from "@reduxjs/toolkit";
import type { EABatchDetailVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveEducationalAdvisorBatch = createApiThunk<EABatchDetailVM, string>(
  "educationalAdvisor/retrieveBatch",
  async (id: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.batchDetail(id);
  },
);

export const resetRetrieveEducationalAdvisorBatch = createAction("educationalAdvisor/resetRetrieveBatch");
